import React from 'react';
import MainRoutes from './routes/main.routes';
import { ProviderViewport, ProviderVersion } from './providers';
import './App.css';

function App() {
  return (
    <ProviderViewport>
      <ProviderVersion>
      <MainRoutes />
      </ProviderVersion>
    </ProviderViewport>
  );
}

export default App;